export function getUniversalCsvTemplate(): string {
  const headers = [
    'Title',
    'Author',
    'ISBN',
    'ISBN13',
    'My Rating',
    'Average Rating',
    'Publisher',
    'Binding',
    'Number of Pages',
    'Year Published',
    'Original Publication Year',
    'Date Read',
    'Date Added',
    'Bookshelves',
    'My Review',
  ].join(',')

  const exampleRow = [
    '"The Silent Echo"',
    '"Elena Richards"',
    '1234567890',
    '9781234567890',
    '5',
    '4.8',
    '"Indie Press"',
    'Paperback',
    '320',
    '2023',
    '2023',
    '2023/10/15',
    '2023/10/01',
    '"read, favorites, fantasy"',
    '"Absolutely loved this book! The magic system was unique."',
  ].join(',')

  return `${headers}\n${exampleRow}`
}

export function parseGoodreadsCsv(fileContent: string): any[] {
  // In a real app, this would use a robust CSV parser like PapaParse
  // For this mockup, we'll just return a simulated array of parsed objects
  return []
}

/**
 * Attempts to parse various date formats and convert them to DD/MM/YYYY (Australian standard).
 * Handles formats like:
 * - YYYY/MM/DD
 * - YYYY-MM-DD
 * - MM/DD/YYYY
 * - Month DD, YYYY
 */
export function parseAndFormatDate(
  dateStr: string | undefined,
): string | undefined {
  if (!dateStr) return undefined

  // Clean the string
  const cleanStr = dateStr.trim()
  if (!cleanStr) return undefined

  // Try to parse with native Date (works for YYYY-MM-DD, YYYY/MM/DD, Month DD YYYY)
  const date = new Date(cleanStr)

  if (!isNaN(date.getTime())) {
    // Valid date, format as DD/MM/YYYY
    const day = date.getDate().toString().padStart(2, '0')
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    const year = date.getFullYear()
    return `${day}/${month}/${year}`
  }

  // If native parsing fails, try to handle specific formats manually
  // Example: DD/MM/YYYY (already in correct format, just validate)
  const ddMmyyyyMatch = cleanStr.match(
    /^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{4})$/,
  )
  if (ddMmyyyyMatch) {
    // We assume it might be DD/MM/YYYY or MM/DD/YYYY.
    // If first number > 12, it must be DD.
    const part1 = parseInt(ddMmyyyyMatch[1], 10)
    const part2 = parseInt(ddMmyyyyMatch[2], 10)
    const year = ddMmyyyyMatch[3]

    if (part1 > 12) {
      // Definitely DD/MM/YYYY
      return `${part1.toString().padStart(2, '0')}/${part2.toString().padStart(2, '0')}/${year}`
    } else if (part2 > 12) {
      // Definitely MM/DD/YYYY
      return `${part2.toString().padStart(2, '0')}/${part1.toString().padStart(2, '0')}/${year}`
    } else {
      // Ambiguous (e.g. 05/06/2023). Default to assuming it's already DD/MM/YYYY
      // since that's our target format, or fallback to native parsing behavior.
      return `${part1.toString().padStart(2, '0')}/${part2.toString().padStart(2, '0')}/${year}`
    }
  }

  // Return original string if we can't parse it
  return cleanStr
}

export function parseStorygraphCsv(fileContent: string): any[] {
  return []
}
